import {
 JsonSchema
} from './types';

export const schemaExamples: Record<string, JsonSchema> = {
    user: {
        type: 'object',
        properties: {
            id: {
                type: 'number'
            },
            name: {
                type: 'string'
            },
            email: {
                type: 'string'
            },
            active: {
                type: 'boolean'
            },
        },
        required: ['id', 'name', 'email'],
    },

    product: {
        type: 'object',
        properties: {
            id: {
                type: 'number'
            },
            title: {
                type: 'string'
            },
            price: {
                type: 'number'
            },
            description: {
                type: 'string'
            },
            category: {
                type: 'string'
            },
            image: {
                type: 'string'
            },
        },
        required: ['id', 'title', 'price'],
    },

    posts: {
        type: 'array',
        items: {
            type: 'object',
            properties: {
                id: {
                    type: 'number'
                },
                title: {
                    type: 'string'
                },
                body: {
                    type: 'string'
                },
                userId: {
                    type: 'number'
                },
            },
            required: ['id', 'title'],
        },
    },

    error: {
        type: 'object',
        properties: {
            error: {
                type: 'string'
            },
            code: {
                type: 'number'
            },
        },
        required: ['error'],
    },

    articles: {
        type: 'object',
        properties: {
            totalArticles: {
                type: 'number'
            },
            articles: {
                type: 'array',
                items: {
                    type: 'object',
                    properties: {
                        title: {
                            type: 'string'
                        },
                        description: {
                            type: 'string'
                        },
                        content: {
                            type: 'string'
                        },
                        url: {
                            type: 'string'
                        },
                        image: {
                            type: 'string'
                        },
                        publishedAt: {
                            type: 'string'
                        },
                        source: {
                            type: 'object',
                            properties: {
                                name: {
                                    type: 'string'
                                },
                                url: {
                                    type: 'string'
                                },
                            },
                            required: ['name', 'url'],
                        },
                    },
                    required: ['title', 'description', 'content', 'url', 'image', 'publishedAt', 'source'],
                },
            },
        },
        required: ['totalArticles', 'articles'],
    },
};
